import './header';
import './footer';
import './newsletter';

window.addEventListener('scroll', function () {
  const footer = document.getElementById('footer');
  const button = document.getElementById('widget-whatsapp');

  const footerTop = footer.getBoundingClientRect().top;
  const windowHeight = window.innerHeight;

  if (footerTop < windowHeight) {
    button.classList.add('bump-up');
  } else {
    button.classList.remove('bump-up');
  }
});

$(document).ready(function () {
  // Função para obter os estilos de um elemento
  function getStyles(element) {
    const computedStyle = window.getComputedStyle(element);
    return {
      fontSize: computedStyle.fontSize,
      fontWeight: computedStyle.fontWeight,
      fontStyle: computedStyle.fontStyle
    };
  }

  // Função para contar as ocorrências de cada estilo
  function countStyles(stylesArray) {
    return stylesArray.reduce((acc, style) => {
      for (const key in style) {
        if (!acc[key]) acc[key] = {};
        if (!acc[key][style[key]]) acc[key][style[key]] = 0;
        acc[key][style[key]]++;
      }
      return acc;
    }, {});
  }

  // Função para encontrar o estilo mais comum
  function findMostCommonStyle(countedStyles) {
    const mostCommon = {};
    for (const key in countedStyles) {
      let maxCount = 0;
      let mostCommonValue = '';
      for (const value in countedStyles[key]) {
        if (countedStyles[key][value] > maxCount) {
          maxCount = countedStyles[key][value];
          mostCommonValue = value;
        }
      }
      mostCommon[key] = mostCommonValue;
    }
    return mostCommon;
  }

  // Função principal para ajustar estilos
  function adjustStyles() {
    const slickTrack = document.querySelector('.slick-track');
    if (!slickTrack) return;

    const slides = slickTrack.querySelectorAll('.slick-slide');
    const headers = [];

    slides.forEach(slide => {
      const h4Elements = slide.querySelectorAll('h4.texto-header__text');
      h4Elements.forEach(h4 => {
        headers.push(getStyles(h4));
      });
    });

    if (headers.length === 0) return;

    const countedStyles = countStyles(headers);
    const mostCommonStyle = findMostCommonStyle(countedStyles);

    headers.forEach(styles => {
      for (const key in mostCommonStyle) {
        if (styles[key] !== mostCommonStyle[key]) {
          // Altera o estilo para o mais comum
          document.querySelectorAll('h4.texto-header__text').forEach(h4 => {
            h4.style[key] = mostCommonStyle[key];
          });
        }
      }
    });
  }

  adjustStyles();
});

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      /// Verifica se a sessionStorage é suportada pelo navegador
       if (typeof(Storage) !== "undefined") {

        let url = window.location.href;
        let domain = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img)

        let value = sessionStorage.getItem(`cart-preview-cache-${domain}`);
        let cartPreview = document.querySelector('.cart-preview');
        if(cartPreview) {
          if (value !== null) {
            let ObjectValue = JSON.parse(value);
            let htmlItens = ObjectValue.html_itens
            let itensCartPreview = document.querySelector('.items_cart_preview');
            itensCartPreview.innerHTML = htmlItens
          } else {
              console.log("Não há valor armazenado para a chave fornecida.");
          }
        }

       } else {
         console.log("Desculpe, seu navegador não suporta sessionStorage.");
       }
     }
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });
});

// GET WIDGETS LOADED ON SCROLL -- Esse Script ativa os Widgets dando mouseenter conforme o scroll na pagina. Para produtos com variaçao
(function ($) {
  $.fn.visible = function (partial) {

    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };

})(jQuery);

function loadWidgets(event) {

  $(".product-item:not(.widget-loaded)").each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("widget-loaded");
      $(el).children().trigger("mouseenter");
    } else {
      //el.removeClass("visible");
    }
  });
}

$(window).scroll(loadWidgets);
setTimeout(loadWidgets, 0);